import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/header.jsx");
